import React from 'react';
import { useNavigate } from 'react-router-dom';

import ContactUs from '@app/components/UI/ContactUs/ContactUs';
import styles from '@app/components/UI/ErrorPageContent/ErrorPageContent.module.scss';
import CustomModal from '@app/components/UI/Modal/CustomModal';
import { AppRoute } from '@app/utils/appRoutes';

interface Props {
	visibleModal?: boolean;
	onChangeVisibleModal?: (val: boolean) => void;
}

const ErrorPageContent: React.FC<Props> = ({ visibleModal, onChangeVisibleModal }) => {
	const navigate = useNavigate();
	const [visible, setVisible] = React.useState<boolean>(visibleModal ?? false);

	const toggleModal = (val: boolean) => (onChangeVisibleModal ? onChangeVisibleModal(val) : setVisible(val));

	return (
		<div className={styles.container}>
			<h1>Whoops, something went wrong</h1>
			<p>Please either refresh the page or return home to try again.</p>
			<p>
				If the issue continues, please
				{' '}
				<span className="inline-link" onClick={() => toggleModal(true)}>
					get in touch.
				</span>
			</p>
			<button className="btn btn-md btn-light-purple" onClick={() => navigate(AppRoute.ROOT)}>
				Go home
			</button>
			{visibleModal || visible && (
				<CustomModal
					modalVisible={visibleModal || visible}
					setModalVisible={toggleModal}
				>
					<ContactUs onChangeVisibleModal={toggleModal} />
				</CustomModal>
			)}
		</div>
	);
};

export default ErrorPageContent;
